import { chain } from 'lodash';
import { useMemo } from 'react';

import { EntitlementType } from '@dreryk/drerykweb-medical-dictionaries-api';

import { isEntitlementRequiredDocumentMissing } from '~libs.shared.prescription';

import { DraftPrescriptionsFieldArray } from '../DraftPrescriptionsForm.types';

export const useEntitlementsRequiredDocumentMissing = (
   draftPrescriptions: DraftPrescriptionsFieldArray
): EntitlementType[] => {
   return useMemo<EntitlementType[]>(() => {
      return chain(draftPrescriptions)
         .flatMap((draftPrescription) => draftPrescription.data.additionalEntitlements)
         .compact()
         .uniqBy('additionalEntitlementType')
         .filter(isEntitlementRequiredDocumentMissing)
         .map((entitlement) => entitlement.additionalEntitlementType ?? null)
         .value();
   }, [draftPrescriptions]);
};
